
// Complete ISO 3166-1 alpha-2 country codes with display names
export const COUNTRIES = [
  { code: 'AD', name: 'Andorra', region: 'Europe' },
  { code: 'AE', name: 'United Arab Emirates', region: 'Middle East' },
  { code: 'AF', name: 'Afghanistan', region: 'Asia' },
  { code: 'AG', name: 'Antigua and Barbuda', region: 'Caribbean' },
  { code: 'AI', name: 'Anguilla', region: 'Caribbean' },
  { code: 'AL', name: 'Albania', region: 'Europe' },
  { code: 'AM', name: 'Armenia', region: 'Asia' },
  { code: 'AO', name: 'Angola', region: 'Africa' },
  { code: 'AQ', name: 'Antarctica', region: 'Antarctica' },
  { code: 'AR', name: 'Argentina', region: 'South America' },
  { code: 'AS', name: 'American Samoa', region: 'Oceania' },
  { code: 'AT', name: 'Austria', region: 'Europe' },
  { code: 'AU', name: 'Australia', region: 'Oceania' },
  { code: 'AW', name: 'Aruba', region: 'Caribbean' },
  { code: 'AX', name: 'Åland Islands', region: 'Europe' },
  { code: 'AZ', name: 'Azerbaijan', region: 'Asia' },
  { code: 'BA', name: 'Bosnia and Herzegovina', region: 'Europe' },
  { code: 'BB', name: 'Barbados', region: 'Caribbean' },
  { code: 'BD', name: 'Bangladesh', region: 'Asia' },
  { code: 'BE', name: 'Belgium', region: 'Europe' },
  { code: 'BF', name: 'Burkina Faso', region: 'Africa' },
  { code: 'BG', name: 'Bulgaria', region: 'Europe' },
  { code: 'BH', name: 'Bahrain', region: 'Middle East' },
  { code: 'BI', name: 'Burundi', region: 'Africa' },
  { code: 'BJ', name: 'Benin', region: 'Africa' },
  { code: 'BL', name: 'Saint Barthélemy', region: 'Caribbean' },
  { code: 'BM', name: 'Bermuda', region: 'North America' },
  { code: 'BN', name: 'Brunei', region: 'Asia' },
  { code: 'BO', name: 'Bolivia', region: 'South America' },
  { code: 'BQ', name: 'Caribbean Netherlands', region: 'Caribbean' },
  { code: 'BR', name: 'Brazil', region: 'South America' },
  { code: 'BS', name: 'Bahamas', region: 'Caribbean' },
  { code: 'BT', name: 'Bhutan', region: 'Asia' },
  { code: 'BV', name: 'Bouvet Island', region: 'Antarctica' },
  { code: 'BW', name: 'Botswana', region: 'Africa' },
  { code: 'BY', name: 'Belarus', region: 'Europe' },
  { code: 'BZ', name: 'Belize', region: 'Central America' },
  { code: 'CA', name: 'Canada', region: 'North America' },
  { code: 'CC', name: 'Cocos Islands', region: 'Asia' },
  { code: 'CD', name: 'Democratic Republic of the Congo', region: 'Africa' },
  { code: 'CF', name: 'Central African Republic', region: 'Africa' },
  { code: 'CG', name: 'Republic of the Congo', region: 'Africa' },
  { code: 'CH', name: 'Switzerland', region: 'Europe' },
  { code: 'CI', name: 'Côte d\'Ivoire', region: 'Africa' },
  { code: 'CK', name: 'Cook Islands', region: 'Oceania' },
  { code: 'CL', name: 'Chile', region: 'South America' },
  { code: 'CM', name: 'Cameroon', region: 'Africa' },
  { code: 'CN', name: 'China', region: 'Asia' },
  { code: 'CO', name: 'Colombia', region: 'South America' },
  { code: 'CR', name: 'Costa Rica', region: 'Central America' },
  { code: 'CU', name: 'Cuba', region: 'Caribbean' },
  { code: 'CV', name: 'Cape Verde', region: 'Africa' },
  { code: 'CW', name: 'Curaçao', region: 'Caribbean' },
  { code: 'CX', name: 'Christmas Island', region: 'Asia' },
  { code: 'CY', name: 'Cyprus', region: 'Europe' },
  { code: 'CZ', name: 'Czech Republic', region: 'Europe' },
  { code: 'DE', name: 'Germany', region: 'Europe' },
  { code: 'DJ', name: 'Djibouti', region: 'Africa' },
  { code: 'DK', name: 'Denmark', region: 'Europe' },
  { code: 'DM', name: 'Dominica', region: 'Caribbean' },
  { code: 'DO', name: 'Dominican Republic', region: 'Caribbean' },
  { code: 'DZ', name: 'Algeria', region: 'Africa' },
  { code: 'EC', name: 'Ecuador', region: 'South America' },
  { code: 'EE', name: 'Estonia', region: 'Europe' },
  { code: 'EG', name: 'Egypt', region: 'Africa' },
  { code: 'EH', name: 'Western Sahara', region: 'Africa' },
  { code: 'ER', name: 'Eritrea', region: 'Africa' },
  { code: 'ES', name: 'Spain', region: 'Europe' },
  { code: 'ET', name: 'Ethiopia', region: 'Africa' },
  { code: 'FI', name: 'Finland', region: 'Europe' },
  { code: 'FJ', name: 'Fiji', region: 'Oceania' },
  { code: 'FK', name: 'Falkland Islands', region: 'South America' },
  { code: 'FM', name: 'Micronesia', region: 'Oceania' },
  { code: 'FO', name: 'Faroe Islands', region: 'Europe' },
  { code: 'FR', name: 'France', region: 'Europe' },
  { code: 'GA', name: 'Gabon', region: 'Africa' },
  { code: 'GB', name: 'United Kingdom', region: 'Europe' },
  { code: 'GD', name: 'Grenada', region: 'Caribbean' },
  { code: 'GE', name: 'Georgia', region: 'Asia' },
  { code: 'GF', name: 'French Guiana', region: 'South America' },
  { code: 'GG', name: 'Guernsey', region: 'Europe' },
  { code: 'GH', name: 'Ghana', region: 'Africa' },
  { code: 'GI', name: 'Gibraltar', region: 'Europe' },
  { code: 'GL', name: 'Greenland', region: 'North America' },
  { code: 'GM', name: 'Gambia', region: 'Africa' },
  { code: 'GN', name: 'Guinea', region: 'Africa' },
  { code: 'GP', name: 'Guadeloupe', region: 'Caribbean' },
  { code: 'GQ', name: 'Equatorial Guinea', region: 'Africa' },
  { code: 'GR', name: 'Greece', region: 'Europe' },
  { code: 'GS', name: 'South Georgia and the South Sandwich Islands', region: 'Antarctica' },
  { code: 'GT', name: 'Guatemala', region: 'Central America' },
  { code: 'GU', name: 'Guam', region: 'Oceania' },
  { code: 'GW', name: 'Guinea-Bissau', region: 'Africa' },
  { code: 'GY', name: 'Guyana', region: 'South America' },
  { code: 'HK', name: 'Hong Kong', region: 'Asia' },
  { code: 'HM', name: 'Heard Island and McDonald Islands', region: 'Antarctica' },
  { code: 'HN', name: 'Honduras', region: 'Central America' },
  { code: 'HR', name: 'Croatia', region: 'Europe' },
  { code: 'HT', name: 'Haiti', region: 'Caribbean' },
  { code: 'HU', name: 'Hungary', region: 'Europe' },
  { code: 'ID', name: 'Indonesia', region: 'Asia' },
  { code: 'IE', name: 'Ireland', region: 'Europe' },
  { code: 'IL', name: 'Israel', region: 'Middle East' },
  { code: 'IM', name: 'Isle of Man', region: 'Europe' },
  { code: 'IN', name: 'India', region: 'Asia' },
  { code: 'IO', name: 'British Indian Ocean Territory', region: 'Asia' },
  { code: 'IQ', name: 'Iraq', region: 'Middle East' },
  { code: 'IR', name: 'Iran', region: 'Middle East' },
  { code: 'IS', name: 'Iceland', region: 'Europe' },
  { code: 'IT', name: 'Italy', region: 'Europe' },
  { code: 'JE', name: 'Jersey', region: 'Europe' },
  { code: 'JM', name: 'Jamaica', region: 'Caribbean' },
  { code: 'JO', name: 'Jordan', region: 'Middle East' },
  { code: 'JP', name: 'Japan', region: 'Asia' },
  { code: 'KE', name: 'Kenya', region: 'Africa' },
  { code: 'KG', name: 'Kyrgyzstan', region: 'Asia' },
  { code: 'KH', name: 'Cambodia', region: 'Asia' },
  { code: 'KI', name: 'Kiribati', region: 'Oceania' },
  { code: 'KM', name: 'Comoros', region: 'Africa' },
  { code: 'KN', name: 'Saint Kitts and Nevis', region: 'Caribbean' },
  { code: 'KP', name: 'North Korea', region: 'Asia' },
  { code: 'KR', name: 'South Korea', region: 'Asia' },
  { code: 'KW', name: 'Kuwait', region: 'Middle East' },
  { code: 'KY', name: 'Cayman Islands', region: 'Caribbean' },
  { code: 'KZ', name: 'Kazakhstan', region: 'Asia' },
  { code: 'LA', name: 'Laos', region: 'Asia' },
  { code: 'LB', name: 'Lebanon', region: 'Middle East' },
  { code: 'LC', name: 'Saint Lucia', region: 'Caribbean' },
  { code: 'LI', name: 'Liechtenstein', region: 'Europe' },
  { code: 'LK', name: 'Sri Lanka', region: 'Asia' },
  { code: 'LR', name: 'Liberia', region: 'Africa' },
  { code: 'LS', name: 'Lesotho', region: 'Africa' },
  { code: 'LT', name: 'Lithuania', region: 'Europe' },
  { code: 'LU', name: 'Luxembourg', region: 'Europe' },
  { code: 'LV', name: 'Latvia', region: 'Europe' },
  { code: 'LY', name: 'Libya', region: 'Africa' },
  { code: 'MA', name: 'Morocco', region: 'Africa' },
  { code: 'MC', name: 'Monaco', region: 'Europe' },
  { code: 'MD', name: 'Moldova', region: 'Europe' },
  { code: 'ME', name: 'Montenegro', region: 'Europe' },
  { code: 'MF', name: 'Saint Martin', region: 'Caribbean' },
  { code: 'MG', name: 'Madagascar', region: 'Africa' },
  { code: 'MH', name: 'Marshall Islands', region: 'Oceania' },
  { code: 'MK', name: 'North Macedonia', region: 'Europe' },
  { code: 'ML', name: 'Mali', region: 'Africa' },
  { code: 'MM', name: 'Myanmar', region: 'Asia' },
  { code: 'MN', name: 'Mongolia', region: 'Asia' },
  { code: 'MO', name: 'Macau', region: 'Asia' },
  { code: 'MP', name: 'Northern Mariana Islands', region: 'Oceania' },
  { code: 'MQ', name: 'Martinique', region: 'Caribbean' },
  { code: 'MR', name: 'Mauritania', region: 'Africa' },
  { code: 'MS', name: 'Montserrat', region: 'Caribbean' },
  { code: 'MT', name: 'Malta', region: 'Europe' },
  { code: 'MU', name: 'Mauritius', region: 'Africa' },
  { code: 'MV', name: 'Maldives', region: 'Asia' },
  { code: 'MW', name: 'Malawi', region: 'Africa' },
  { code: 'MX', name: 'Mexico', region: 'North America' },
  { code: 'MY', name: 'Malaysia', region: 'Asia' },
  { code: 'MZ', name: 'Mozambique', region: 'Africa' },
  { code: 'NA', name: 'Namibia', region: 'Africa' },
  { code: 'NC', name: 'New Caledonia', region: 'Oceania' },
  { code: 'NE', name: 'Niger', region: 'Africa' },
  { code: 'NF', name: 'Norfolk Island', region: 'Oceania' },
  { code: 'NG', name: 'Nigeria', region: 'Africa' },
  { code: 'NI', name: 'Nicaragua', region: 'Central America' },
  { code: 'NL', name: 'Netherlands', region: 'Europe' },
  { code: 'NO', name: 'Norway', region: 'Europe' },
  { code: 'NP', name: 'Nepal', region: 'Asia' },
  { code: 'NR', name: 'Nauru', region: 'Oceania' },
  { code: 'NU', name: 'Niue', region: 'Oceania' },
  { code: 'NZ', name: 'New Zealand', region: 'Oceania' },
  { code: 'OM', name: 'Oman', region: 'Middle East' },
  { code: 'PA', name: 'Panama', region: 'Central America' },
  { code: 'PE', name: 'Peru', region: 'South America' },
  { code: 'PF', name: 'French Polynesia', region: 'Oceania' },
  { code: 'PG', name: 'Papua New Guinea', region: 'Oceania' },
  { code: 'PH', name: 'Philippines', region: 'Asia' },
  { code: 'PK', name: 'Pakistan', region: 'Asia' },
  { code: 'PL', name: 'Poland', region: 'Europe' },
  { code: 'PM', name: 'Saint Pierre and Miquelon', region: 'North America' },
  { code: 'PN', name: 'Pitcairn', region: 'Oceania' },
  { code: 'PR', name: 'Puerto Rico', region: 'Caribbean' },
  { code: 'PS', name: 'Palestine', region: 'Middle East' },
  { code: 'PT', name: 'Portugal', region: 'Europe' },
  { code: 'PW', name: 'Palau', region: 'Oceania' },
  { code: 'PY', name: 'Paraguay', region: 'South America' },
  { code: 'QA', name: 'Qatar', region: 'Middle East' },
  { code: 'RE', name: 'Réunion', region: 'Africa' },
  { code: 'RO', name: 'Romania', region: 'Europe' },
  { code: 'RS', name: 'Serbia', region: 'Europe' },
  { code: 'RU', name: 'Russia', region: 'Europe' },
  { code: 'RW', name: 'Rwanda', region: 'Africa' },
  { code: 'SA', name: 'Saudi Arabia', region: 'Middle East' },
  { code: 'SB', name: 'Solomon Islands', region: 'Oceania' },
  { code: 'SC', name: 'Seychelles', region: 'Africa' },
  { code: 'SD', name: 'Sudan', region: 'Africa' },
  { code: 'SE', name: 'Sweden', region: 'Europe' },
  { code: 'SG', name: 'Singapore', region: 'Asia' },
  { code: 'SH', name: 'Saint Helena', region: 'Africa' },
  { code: 'SI', name: 'Slovenia', region: 'Europe' },
  { code: 'SJ', name: 'Svalbard and Jan Mayen', region: 'Europe' },
  { code: 'SK', name: 'Slovakia', region: 'Europe' },
  { code: 'SL', name: 'Sierra Leone', region: 'Africa' },
  { code: 'SM', name: 'San Marino', region: 'Europe' },
  { code: 'SN', name: 'Senegal', region: 'Africa' },
  { code: 'SO', name: 'Somalia', region: 'Africa' },
  { code: 'SR', name: 'Suriname', region: 'South America' },
  { code: 'SS', name: 'South Sudan', region: 'Africa' },
  { code: 'ST', name: 'São Tomé and Príncipe', region: 'Africa' },
  { code: 'SV', name: 'El Salvador', region: 'Central America' },
  { code: 'SX', name: 'Sint Maarten', region: 'Caribbean' },
  { code: 'SY', name: 'Syria', region: 'Middle East' },
  { code: 'SZ', name: 'Eswatini', region: 'Africa' },
  { code: 'TC', name: 'Turks and Caicos Islands', region: 'Caribbean' },
  { code: 'TD', name: 'Chad', region: 'Africa' },
  { code: 'TF', name: 'French Southern Territories', region: 'Antarctica' },
  { code: 'TG', name: 'Togo', region: 'Africa' },
  { code: 'TH', name: 'Thailand', region: 'Asia' },
  { code: 'TJ', name: 'Tajikistan', region: 'Asia' },
  { code: 'TK', name: 'Tokelau', region: 'Oceania' },
  { code: 'TL', name: 'Timor-Leste', region: 'Asia' },
  { code: 'TM', name: 'Turkmenistan', region: 'Asia' },
  { code: 'TN', name: 'Tunisia', region: 'Africa' },
  { code: 'TO', name: 'Tonga', region: 'Oceania' },
  { code: 'TR', name: 'Turkey', region: 'Europe' },
  { code: 'TT', name: 'Trinidad and Tobago', region: 'Caribbean' },
  { code: 'TV', name: 'Tuvalu', region: 'Oceania' },
  { code: 'TW', name: 'Taiwan', region: 'Asia' },
  { code: 'TZ', name: 'Tanzania', region: 'Africa' },
  { code: 'UA', name: 'Ukraine', region: 'Europe' },
  { code: 'UG', name: 'Uganda', region: 'Africa' },
  { code: 'UM', name: 'United States Minor Outlying Islands', region: 'Oceania' },
  { code: 'US', name: 'United States', region: 'North America' },
  { code: 'UY', name: 'Uruguay', region: 'South America' },
  { code: 'UZ', name: 'Uzbekistan', region: 'Asia' },
  { code: 'VA', name: 'Vatican City', region: 'Europe' },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', region: 'Caribbean' },
  { code: 'VE', name: 'Venezuela', region: 'South America' },
  { code: 'VG', name: 'British Virgin Islands', region: 'Caribbean' },
  { code: 'VI', name: 'U.S. Virgin Islands', region: 'Caribbean' },
  { code: 'VN', name: 'Vietnam', region: 'Asia' },
  { code: 'VU', name: 'Vanuatu', region: 'Oceania' },
  { code: 'WF', name: 'Wallis and Futuna', region: 'Oceania' },
  { code: 'WS', name: 'Samoa', region: 'Oceania' },
  { code: 'YE', name: 'Yemen', region: 'Middle East' },
  { code: 'YT', name: 'Mayotte', region: 'Africa' },
  { code: 'ZA', name: 'South Africa', region: 'Africa' },
  { code: 'ZM', name: 'Zambia', region: 'Africa' },
  { code: 'ZW', name: 'Zimbabwe', region: 'Africa' }
] as const;

// Popular countries for easier selection
export const POPULAR_COUNTRIES = [
  'US', 'GB', 'CA', 'AU', 'DE', 'FR', 'IT', 'ES', 'JP', 'CN', 'IN', 'BR', 'MX', 'RU', 'KR', 'NL', 'SE', 'NO', 'DK', 'FI'
] as const;

export type CountryCode = typeof COUNTRIES[number]['code'];
export type CountryRegion = typeof COUNTRIES[number]['region'];

export interface Country {
  code: CountryCode;
  name: string;
  region: CountryRegion;
}
